import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1a907b3c")
const _hoisted_1 = {
  key: 0,
  class: "_loadPrompt"
}
const _hoisted_2 = {
  key: 1,
  class: "developerGameEdit"
}
const _hoisted_3 = { class: "_header grid_top" }
const _hoisted_4 = { class: "_headerBack" }
const _hoisted_5 = {
  key: 0,
  class: "_headerText"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "_dev" }, "Dev", -1)
const _hoisted_7 = { class: "functions" }
const _hoisted_8 = { class: "_main" }
const _hoisted_9 = { class: "_subheader" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "_card _clear globalData" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Statistics")
  ])
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "_card _clear globalData"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h4", null, "Purchases", -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h4", null, "Ratings", -1)
const _hoisted_20 = { key: 3 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h4", null, "Playthroughs", -1)
const _hoisted_23 = { key: 5 }
const _hoisted_24 = {
  key: 1,
  class: "_card _clear globalData"
}
const _hoisted_25 = {
  key: 2,
  class: "_card _clear globalData"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "_card _clear globalData" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "sectionHeader" }, [
      /*#__PURE__*/_createElementVNode("h2", null, "The room")
    ])
  ])
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Exit types")
], -1)
const _hoisted_28 = { class: "_spacing" }
const _hoisted_29 = { class: "_spacing" }
const _hoisted_30 = { class: "_spacing" }
const _hoisted_31 = { class: "_spacing" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "_card _clear globalData" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "sectionHeader" }, [
      /*#__PURE__*/_createElementVNode("h2", null, "The exit")
    ])
  ])
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Exit types")
], -1)
const _hoisted_34 = { class: "_spacing" }
const _hoisted_35 = { class: "_spacing" }
const _hoisted_36 = { class: "_spacing" }
const _hoisted_37 = { class: "_spacing" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Password")
], -1)
const _hoisted_39 = { class: "_spacing" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_42 = { class: "_spacing" }
const _hoisted_43 = { class: "_spacing" }
const _hoisted_44 = {
  key: 1,
  class: "_spacing"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", null, "By default, if password is not selected, the exit is open.", -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = { key: 4 }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "_card _clear globalData" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Game meta data")
  ])
], -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = { key: 5 }
const _hoisted_51 = { class: "_card _clear globalData" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Billboard image"),
  /*#__PURE__*/_createElementVNode("p", null, "This is the image displayed in the lobby, and on the game cards when browsing.")
], -1)
const _hoisted_53 = { class: "image _spacing" }
const _hoisted_54 = { class: "_spacing" }
const _hoisted_55 = { class: "_spacing" }
const _hoisted_56 = { class: "_spacing" }
const _hoisted_57 = { class: "_spacing" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Difficulty")
], -1)
const _hoisted_59 = { class: "_spacing" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Duration (minutes)"),
  /*#__PURE__*/_createElementVNode("p", null, "Insert numbers only, aim for less than 120.")
], -1)
const _hoisted_61 = { class: "_spacing" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Price (USD) - default is $4.98"),
  /*#__PURE__*/_createElementVNode("p", null, "As a guide, each 10-minutes equates to ~ $1.98 USD")
], -1)
const _hoisted_63 = { class: "_spacing" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Features"),
  /*#__PURE__*/_createElementVNode("p", null, "Decoration to indicate whether the game recruits maps and other webpages.")
], -1)
const _hoisted_65 = { class: "_spacing" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Pipeline"),
  /*#__PURE__*/_createElementVNode("p", null, "Determine to us where you are in the development of this game.")
], -1)
const _hoisted_67 = { class: "_grid" }
const _hoisted_68 = { class: "_spacing" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Attributions")
], -1)
const _hoisted_70 = { key: 0 }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("th", null, "Resource", -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("th", null, "Author", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("th", null, "License link", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("th", null, "Changes", -1)
const _hoisted_75 = [
  _hoisted_71,
  _hoisted_72,
  _hoisted_73,
  _hoisted_74
]
const _hoisted_76 = { class: "functions" }
const _hoisted_77 = { class: "sectionHeader" }
const _hoisted_78 = /*#__PURE__*/_createTextVNode(" You cannot reverse the decision to delete a card. ")
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("h4", null, "Accessory files", -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "sectionHeader" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Questions and answers"),
  /*#__PURE__*/_createElementVNode("p", null, "Aim for no more than 2 questions per card. At least 1 is required.")
], -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_85 = { class: "questions" }
const _hoisted_86 = { class: "header" }
const _hoisted_87 = { class: "inputs" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_89 = { class: "functions" }
const _hoisted_90 = { class: "questionsFunctions" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "sectionHeader" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Notes")
], -1)
const _hoisted_92 = { class: "card" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "sectionHeader" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Assistance tools")
], -1)
const _hoisted_94 = { class: "card" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Maps help"),
  /*#__PURE__*/_createElementVNode("p", null, " These features should be implemented to help users with cards. While the service has functionality which can be used, such as Google Maps' distance measuring feature, it can be difficult for people to use. A \"cheat\" is our way of giving the player the complete, or at least part of the answer. ")
], -1)
const _hoisted_96 = { class: "row" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "_a" }, null, -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "sectionHeader" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Attributions")
], -1)
const _hoisted_101 = { key: 0 }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("th", null, "Resource", -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("th", null, "Author", -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("th", null, "License link", -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("th", null, "Changes", -1)
const _hoisted_106 = [
  _hoisted_102,
  _hoisted_103,
  _hoisted_104,
  _hoisted_105
]
const _hoisted_107 = {
  key: 1,
  class: "_subheader"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadSpinner = _resolveComponent("LoadSpinner")!
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_PageControls = _resolveComponent("PageControls")!
  const _component_MovingIcon = _resolveComponent("MovingIcon")!
  const _component_Room = _resolveComponent("Room")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_LazyImage = _resolveComponent("LazyImage")!
  const _component_Confirm = _resolveComponent("Confirm")!
  const _component_FileUploader = _resolveComponent("FileUploader")!

  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_LoadSpinner, { text: "Loading game..." })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_IconButton, {
              icon: "back",
              white: true,
              onClick: _ctx.returnToBrowse
            }, null, 8, ["onClick"])
          ]),
          (_ctx.$store.state.GameEdit.game)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(_toDisplayString(_ctx.$store.state.GameEdit.game.title), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            (!_ctx.$store.state.GameEdit.creatingCardLoading)
              ? (_openBlock(), _createBlock(_component_IconButton, {
                  key: 0,
                  icon: 'add',
                  type: 'svg',
                  onClick: _ctx.addCard
                }, null, 8, ["onClick"]))
              : (_openBlock(), _createBlock(_component_LoadSpinner, {
                  key: 1,
                  text: "Adding card"
                })),
            _createVNode(_component_IconButton, {
              colored: _ctx.$store.state.GameEdit.reordering,
              text: "Reorder",
              type: "svg",
              onClick: _ctx.reorderCards
            }, null, 8, ["colored", "onClick"]),
            _createVNode(_component_IconButton, {
              text: "Preview",
              type: "svg",
              onClick: _ctx.reviewGame
            }, null, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_PageControls, { gameeditmeta: true })
          ]),
          (!_ctx.$store.state.GameEdit.reordering)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.$store.state.GameEdit.cards.focus == 'stats')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_10, _hoisted_12))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameEdit.cards.focus == 'stats')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_13, [
                      (_ctx.playthroughData && _ctx.purchaseData)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _hoisted_15,
                            (_ctx.purchaseData.number)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Number: " + _toDisplayString(_ctx.purchaseData.number), 1))
                              : (_openBlock(), _createElementBlock("p", _hoisted_17, "No purchases yet")),
                            _hoisted_18,
                            _hoisted_19,
                            (_ctx.ratingData.number > 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createElementVNode("p", null, "Number of ratings: " + _toDisplayString(_ctx.ratingData.number), 1),
                                  _createElementVNode("p", null, "Mean rating: " + _toDisplayString(_ctx.ratingData.avRating), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock("p", _hoisted_20, " No ratings yet ")),
                            _hoisted_21,
                            _hoisted_22,
                            (_ctx.playthroughData.number>0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                  _createElementVNode("p", null, "Number: " + _toDisplayString(_ctx.playthroughData.number), 1),
                                  _createElementVNode("p", null, "Median players per game: " + _toDisplayString(_ctx.playthroughData.avLobbySize), 1),
                                  _createElementVNode("p", null, "Median hints per game: " + _toDisplayString(_ctx.playthroughData.avHints), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock("p", _hoisted_23, "No playthroughs yet"))
                          ]))
                        : (!_ctx.gettingPlaythroughData && !_ctx.gettingPurchaseData)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, " There have been no playthroughs as of yet. "))
                          : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createTextVNode(_toDisplayString(_ctx.getPlaythroughData()) + " " + _toDisplayString(_ctx.getPurchaseData()) + " ", 1),
                              _createVNode(_component_MovingIcon, {
                                name: "loader_spinner",
                                autoplay: true,
                                loop: true
                              })
                            ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameEdit.cards.focus == 'room')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _hoisted_26,
                      _createElementVNode("section", null, [
                        _createVNode(_component_Room, {
                          properties: _ctx.gameRoom,
                          rotatable: true
                        }, null, 8, ["properties"])
                      ]),
                      _createElementVNode("section", null, [
                        _hoisted_27,
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_28, [
                            _createVNode(_component_Dropdown, {
                              options: {
                    active:_ctx.$store.state.GameEdit.game.exitType || 0,
                    options:[
                      {
                        text:'Door',
                      },
                      {
                        text:'Chest',
                      },
                    ]
                  },
                              onUpdate: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                    exitType: $event
                  })))
                            }, null, 8, ["options"])
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _createVNode(_component_TextInput, {
                              limit: 30,
                              label: "Exit prompt",
                              default: _ctx.$store.state.GameEdit.game.exitPrompt,
                              saving: _ctx.saving[_ctx.$store.state.GameEdit.game]?_ctx.saving[_ctx.$store.state.GameEdit.game]['exitPrompt']:false,
                              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                    exitPrompt: $event
                  })))
                            }, null, 8, ["default", "saving"])
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_TextInput, {
                              limit: 30,
                              label: "Escape prompt",
                              default: _ctx.$store.state.GameEdit.game.escapePrompt,
                              saving: _ctx.saving[_ctx.$store.state.GameEdit.game]?_ctx.saving[_ctx.$store.state.GameEdit.game]['escapePrompt']:false,
                              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                    escapePrompt: $event
                  })))
                            }, null, 8, ["default", "saving"])
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_TextInput, {
                              limit: 30,
                              label: "Victory message",
                              default: _ctx.$store.state.GameEdit.game.victoryMessage,
                              saving: _ctx.saving[_ctx.$store.state.GameEdit.game]?_ctx.saving[_ctx.$store.state.GameEdit.game]['victoryMessage']:false,
                              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                    victoryMessage: $event
                  })))
                            }, null, 8, ["default", "saving"])
                          ])
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameEdit.cards.focus == 'door')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _hoisted_32,
                      _createElementVNode("section", null, [
                        _hoisted_33,
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_34, [
                            _createVNode(_component_Dropdown, {
                              options: {
                    active:_ctx.$store.state.GameEdit.game.exitType || 0,
                    options:[
                      {
                        text:'Door',
                      },
                      {
                        text:'Chest',
                      },
                    ]
                  },
                              onUpdate: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                    exitType: $event
                  })))
                            }, null, 8, ["options"])
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_TextInput, {
                              limit: 30,
                              label: "Exit prompt",
                              default: _ctx.$store.state.GameEdit.game.exitPrompt,
                              saving: _ctx.saving[_ctx.$store.state.GameEdit.game]?_ctx.saving[_ctx.$store.state.GameEdit.game]['exitPrompt']:false,
                              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                    exitPrompt: $event
                  })))
                            }, null, 8, ["default", "saving"])
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createVNode(_component_TextInput, {
                              limit: 30,
                              label: "Escape prompt",
                              default: _ctx.$store.state.GameEdit.game.escapePrompt,
                              saving: _ctx.saving[_ctx.$store.state.GameEdit.game]?_ctx.saving[_ctx.$store.state.GameEdit.game]['escapePrompt']:false,
                              onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                    escapePrompt: $event
                  })))
                            }, null, 8, ["default", "saving"])
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _createVNode(_component_TextInput, {
                              limit: 30,
                              label: "Victory message",
                              default: _ctx.$store.state.GameEdit.game.victoryMessage,
                              saving: _ctx.saving[_ctx.$store.state.GameEdit.game]?_ctx.saving[_ctx.$store.state.GameEdit.game]['victoryMessage']:false,
                              onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                    victoryMessage: $event
                  })))
                            }, null, 8, ["default", "saving"])
                          ])
                        ])
                      ]),
                      _createElementVNode("section", null, [
                        _hoisted_38,
                        _createElementVNode("div", _hoisted_39, [
                          _createVNode(_component_Checkbox, {
                            toggled: _ctx.$store.state.GameEdit.game.doorPasswordEnabled,
                            label: "Password exit",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.passwordExitToggle(_ctx.$store.state.GameEdit.game)))
                          }, null, 8, ["toggled"])
                        ]),
                        (_ctx.$store.state.GameEdit.game.doorPasswordEnabled)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _hoisted_41,
                              _createElementVNode("div", _hoisted_42, [
                                _createVNode(_component_TextArea, {
                                  limit: 300,
                                  label: "Exit clue",
                                  default: _ctx.$store.state.GameEdit.game.doorPasswordClue,
                                  saving: _ctx.saving[_ctx.$store.state.GameEdit.game]?_ctx.saving[_ctx.$store.state.GameEdit.game]['doorPasswordClue']:false,
                                  onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                    doorPasswordClue: $event
                  })))
                                }, null, 8, ["default", "saving"])
                              ]),
                              _createElementVNode("div", _hoisted_43, [
                                _createVNode(_component_TextInput, {
                                  placeholder: "Final password",
                                  label: "Final password (options separated by semicolon)",
                                  default: _ctx.$store.state.GameEdit.game.doorPassword,
                                  saving: _ctx.saving[_ctx.$store.state.GameEdit.game]?_ctx.saving[_ctx.$store.state.GameEdit.game]['doorPassword']:false,
                                  onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                    doorPassword: $event
                  })))
                                }, null, 8, ["default", "saving"])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_46))
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameEdit.cards.focus == 'meta')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_47, _hoisted_49))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameEdit.cards.focus == 'meta')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _createElementVNode("div", _hoisted_53, [
                          _createVNode(_component_LazyImage, {
                            upload: true,
                            class: "image",
                            src: _ctx.$store.state.GameEdit.game.image,
                            onNewImageURL: _cache[11] || (_cache[11] = ($event: any) => (_ctx.newGameImage(_ctx.$store.state.GameEdit.game,$event)))
                          }, null, 8, ["src"])
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _createVNode(_component_TextInput, {
                            limit: 25,
                            label: "Title",
                            placeholder: "Title text",
                            default: _ctx.$store.state.GameEdit.game.title,
                            saving: _ctx.saving[_ctx.$store.state.GameEdit.game]?_ctx.saving[_ctx.$store.state.GameEdit.game]['title']:false,
                            onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                  title: $event
                })))
                          }, null, 8, ["default", "saving"])
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _createVNode(_component_TextArea, {
                            limit: 120,
                            label: "Short description",
                            default: _ctx.$store.state.GameEdit.game.shortdescription,
                            saving: _ctx.saving[_ctx.$store.state.GameEdit.game]?_ctx.saving[_ctx.$store.state.GameEdit.game]['shortdescription']:false,
                            onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                  shortdescription: $event
                })))
                          }, null, 8, ["default", "saving"])
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _createVNode(_component_TextArea, {
                            limit: 1000,
                            label: "Full description",
                            default: _ctx.$store.state.GameEdit.game.description,
                            saving: _ctx.saving[_ctx.$store.state.GameEdit.game]?_ctx.saving[_ctx.$store.state.GameEdit.game]['description']:false,
                            onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                  description: $event
                })))
                          }, null, 8, ["default", "saving"])
                        ]),
                        _createElementVNode("div", _hoisted_57, [
                          _hoisted_58,
                          _createVNode(_component_Dropdown, {
                            options: {
                  active:_ctx.$store.state.GameEdit.game.difficulty,
                  options:[
                    {
                      text:'Easy',
                    },
                    {
                      text:'Medium',
                    },
                    {
                      text:'Hard',
                    },
                    {
                      text:'Impossible',
                    }
                  ]
                },
                            onUpdate: _cache[15] || (_cache[15] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                  difficulty: $event
                })))
                          }, null, 8, ["options"])
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _hoisted_60,
                          _createVNode(_component_TextInput, {
                            typing: "number",
                            placeholder: "60",
                            default: _ctx.$store.state.GameEdit.game.minutes,
                            saving: _ctx.saving[_ctx.$store.state.GameEdit.game]?_ctx.saving[_ctx.$store.state.GameEdit.game]['minutes']:false,
                            onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                  minutes: $event
                })))
                          }, null, 8, ["default", "saving"])
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                          _hoisted_62,
                          _createVNode(_component_TextInput, {
                            typing: "number",
                            placeholder: "4.98",
                            default: _ctx.$store.state.GameEdit.game.price,
                            saving: _ctx.saving[_ctx.$store.state.GameEdit.game]?_ctx.saving[_ctx.$store.state.GameEdit.game]['price']:false,
                            onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                  price: $event
                })))
                          }, null, 8, ["default", "saving"])
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          _hoisted_64,
                          _createVNode(_component_IconButton, {
                            icon: "maps",
                            clear: true,
                            transparent: !_ctx.$store.state.GameEdit.game.features.maps,
                            hex: _ctx.$store.state.GameEdit.game.features.maps?'#0000ff':'#000',
                            type: "svg",
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                  features: {
                    ..._ctx.$store.state.GameEdit.game.features,
                    maps:!_ctx.$store.state.GameEdit.game.features.maps
                  }
                })))
                          }, null, 8, ["transparent", "hex"]),
                          _createVNode(_component_IconButton, {
                            icon: "web",
                            clear: true,
                            transparent: !_ctx.$store.state.GameEdit.game.features.web,
                            hex: _ctx.$store.state.GameEdit.game.features.web?'#0000ff':'#000',
                            type: "svg",
                            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                  features: {
                    ..._ctx.$store.state.GameEdit.game.features,
                    web:!_ctx.$store.state.GameEdit.game.features.web
                  }
                })))
                          }, null, 8, ["transparent", "hex"]),
                          _createVNode(_component_IconButton, {
                            icon: "layout",
                            clear: true,
                            transparent: !_ctx.$store.state.GameEdit.game.features.room,
                            hex: _ctx.$store.state.GameEdit.game.features.room?'#0000ff':'#000',
                            type: "svg",
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                  features: {
                    ..._ctx.$store.state.GameEdit.game.features,
                    room:!_ctx.$store.state.GameEdit.game.features.room
                  }
                })))
                          }, null, 8, ["transparent", "hex"]),
                          _createVNode(_component_IconButton, {
                            icon: "start",
                            clear: true,
                            transparent: !_ctx.$store.state.GameEdit.game.features.video,
                            hex: _ctx.$store.state.GameEdit.game.features.video?'#0000ff':'#000',
                            type: "svg",
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                  features: {
                    ..._ctx.$store.state.GameEdit.game.features,
                    video:!_ctx.$store.state.GameEdit.game.features.video
                  }
                })))
                          }, null, 8, ["transparent", "hex"]),
                          _createVNode(_component_IconButton, {
                            icon: "download",
                            clear: true,
                            transparent: !_ctx.$store.state.GameEdit.game.features.downloads,
                            hex: _ctx.$store.state.GameEdit.game.features.downloads?'#0000ff':'#000',
                            type: "svg",
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                  features: {
                    ..._ctx.$store.state.GameEdit.game.features,
                    downloads:!_ctx.$store.state.GameEdit.game.features.downloads
                  }
                })))
                          }, null, 8, ["transparent", "hex"])
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _hoisted_66,
                          _createElementVNode("div", _hoisted_67, [
                            _createVNode(_component_Checkbox, {
                              toggled: _ctx.$store.state.GameEdit.game.free || false,
                              label: "Free game",
                              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.freeGameToggle(_ctx.$store.state.GameEdit.game)))
                            }, null, 8, ["toggled"]),
                            _createVNode(_component_Checkbox, {
                              toggled: _ctx.$store.state.GameEdit.game.ready || false,
                              label: "Ready",
                              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                    ready: !_ctx.$store.state.GameEdit.game.ready
                  })))
                            }, null, 8, ["toggled"]),
                            _createVNode(_component_Checkbox, {
                              toggled: _ctx.$store.state.GameEdit.game.patching || false,
                              label: "Patching",
                              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.updateGameField(_ctx.$store.state.GameEdit.game,{
                    patching: !_ctx.$store.state.GameEdit.game.patching
                  })))
                            }, null, 8, ["toggled"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          _hoisted_69,
                          _createElementVNode("table", null, [
                            (_ctx.$store.state.GameEdit.game.attributions && _ctx.$store.state.GameEdit.game.attributions.length)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_70, _hoisted_75))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.GameEdit.game.attributions, (attr, attrIndex) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                class: _normalizeClass({readonly:_ctx.deletingAttr.includes(attr.id)}),
                                key: `attr_${attr.id}`
                              }, [
                                _createElementVNode("td", null, [
                                  _createVNode(_component_TextInput, {
                                    default: attr.resource,
                                    onChange: ($event: any) => (_ctx.updateAttribution(attr,{
                        resource: $event,
                        author:attr.author,
                        license:attr.license,
                        changes:attr.changes
                      }))
                                  }, null, 8, ["default", "onChange"])
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_TextInput, {
                                    default: attr.author,
                                    onChange: ($event: any) => (_ctx.updateAttribution(attr,{
                        resource: attr.resource,
                        author: $event,
                        license:attr.license,
                        changes:attr.changes
                      }))
                                  }, null, 8, ["default", "onChange"])
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_TextInput, {
                                    default: attr.license,
                                    onChange: ($event: any) => (_ctx.updateAttribution(attr,{
                        resource: attr.resource,
                        author: attr.author,
                        license: $event,
                        changes:attr.changes
                      }))
                                  }, null, 8, ["default", "onChange"])
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_Dropdown, {
                                    options: {
                        active:attr.changes || 0,
                        options:[{
                          text:'False',
                          icon:''
                        },{
                          text:'True',
                          icon:''
                        }]
                      },
                                    onUpdate: ($event: any) => (_ctx.updateAttribution(attr,{
                        resource: attr.resource,
                        author: attr.author,
                        license: attr.license,
                        changes: $event
                      }))
                                  }, null, 8, ["options", "onUpdate"])
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_IconButton, {
                                    icon: _ctx.deletingAttr.includes(attr.id)?'loader_spinner':'cross',
                                    autoplay: _ctx.deletingAttr.includes(attr.id)?true:false,
                                    loop: _ctx.deletingAttr.includes(attr.id)?true:false,
                                    onClick: ($event: any) => (_ctx.deleteAttribution(_ctx.$store.state.GameEdit.game,attrIndex))
                                  }, null, 8, ["icon", "autoplay", "loop", "onClick"])
                                ])
                              ], 2))
                            }), 128)),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", null, [
                                _createVNode(_component_IconButton, {
                                  text: _ctx.addingAttr.length?'Adding':'Add',
                                  icon: _ctx.addingAttr.length?'loader_spinner':'',
                                  autoplay: _ctx.addingAttr.length?true:false,
                                  loop: _ctx.addingAttr.length?true:false,
                                  onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.newAttribution(_ctx.$store.state.GameEdit.game)))
                                }, null, 8, ["text", "icon", "autoplay", "loop"])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.GameEdit.cards.data)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 6 }, _renderList(_ctx.$store.state.GameEdit.cards.data, (card, cardIndex) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (card && card.index == _ctx.$store.state.GameEdit.cards.focus)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("section", null, [
                                _createElementVNode("div", _hoisted_76, [
                                  _createElementVNode("div", _hoisted_77, [
                                    _createElementVNode("h3", null, "Card: " + _toDisplayString(card.id), 1)
                                  ]),
                                  _createVNode(_component_IconButton, {
                                    icon: "delete",
                                    type: "svg",
                                    onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.requestRemoveCard()))
                                  }),
                                  (_ctx.removeRequested)
                                    ? (_openBlock(), _createBlock(_component_Confirm, {
                                        key: 0,
                                        pending: _ctx.removeInvoked,
                                        onResolve: ($event: any) => (_ctx.approveRemoveCard(card)),
                                        onReject: _cache[28] || (_cache[28] = ($event: any) => (_ctx.rejectRemoveCard())),
                                        text: "Delete"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_78
                                        ]),
                                        _: 2
                                      }, 1032, ["pending", "onResolve"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("section", null, [
                                _createVNode(_component_LazyImage, {
                                  upload: true,
                                  class: "image",
                                  src: card.image,
                                  onNewImageURL: ($event: any) => (_ctx.updateCardField(card,{
                  image: $event
                }))
                                }, null, 8, ["src", "onNewImageURL"]),
                                _hoisted_79,
                                _createVNode(_component_TextInput, {
                                  default: card.title,
                                  limit: 25,
                                  label: "Header",
                                  placeholder: "Header",
                                  onChange: ($event: any) => (_ctx.updateCardField(card,{
                  title: $event
                }))
                                }, null, 8, ["default", "onChange"]),
                                _hoisted_80,
                                _createVNode(_component_TextArea, {
                                  default: card.description,
                                  limit: 500,
                                  label: "Instructions",
                                  onChange: ($event: any) => (_ctx.updateCardField(card,{
                  description: $event
                }))
                                }, null, 8, ["default", "onChange"]),
                                _hoisted_81,
                                _createVNode(_component_TextArea, {
                                  default: card.hint,
                                  limit: 150,
                                  label: "Hint",
                                  onChange: ($event: any) => (_ctx.updateCardField(card,{
                  hint: $event
                }))
                                }, null, 8, ["default", "onChange"])
                              ]),
                              _createElementVNode("section", null, [
                                _hoisted_82,
                                _createVNode(_component_FileUploader, {
                                  white: true,
                                  multiple: true,
                                  files: card.uploads,
                                  onPreview: _cache[29] || (_cache[29] = ($event: any) => (_ctx.uploaderPreview('upload',$event))),
                                  onUploaded: ($event: any) => (_ctx.updateCardField(card,{
                  uploads: $event
                })),
                                  onPercentage: _cache[30] || (_cache[30] = ($event: any) => (_ctx.fileUploadPerc=$event)),
                                  ref: "fileUploader"
                                }, null, 8, ["files", "onUploaded"])
                              ]),
                              _createElementVNode("section", null, [
                                _hoisted_83,
                                _hoisted_84,
                                _createElementVNode("div", _hoisted_85, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.questions, (question, questionIndex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "question",
                                      key: question.id
                                    }, [
                                      _createElementVNode("div", _hoisted_86, [
                                        _createElementVNode("p", null, "ID: " + _toDisplayString(question.id), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_87, [
                                        _createVNode(_component_TextInput, {
                                          limit: 150,
                                          label: "Question (optional)",
                                          placeholder: "Question",
                                          default: question.question,
                                          onChange: ($event: any) => (_ctx.updateQuestion(question,{
                        question: $event
                      }))
                                        }, null, 8, ["default", "onChange"]),
                                        _hoisted_88,
                                        _createVNode(_component_TextInput, {
                                          label: "Accepted answers (split by semicolon)",
                                          placeholder: "Answer",
                                          default: question.acceptedValues,
                                          onChange: ($event: any) => (_ctx.updateQuestion(question,{
                        acceptedValues: $event
                      }))
                                        }, null, 8, ["default", "onChange"])
                                      ]),
                                      _createElementVNode("div", _hoisted_89, [
                                        _createVNode(_component_IconButton, {
                                          text: "Delete",
                                          onClick: ($event: any) => (_ctx.removeQuestion(cardIndex,questionIndex))
                                        }, null, 8, ["onClick"])
                                      ])
                                    ]))
                                  }), 128)),
                                  _createElementVNode("div", _hoisted_90, [
                                    _createVNode(_component_IconButton, {
                                      text: "Add question",
                                      onClick: ($event: any) => (_ctx.addQuestion(card))
                                    }, null, 8, ["onClick"])
                                  ])
                                ]),
                                _hoisted_91,
                                _createElementVNode("div", _hoisted_92, [
                                  _createVNode(_component_TextArea, {
                                    default: card.notes,
                                    label: "Provide notes (optional)",
                                    limit: 100,
                                    onChange: ($event: any) => (_ctx.updateCardField(card,{
                    notes: $event
                  }))
                                  }, null, 8, ["default", "onChange"])
                                ]),
                                _hoisted_93,
                                _createElementVNode("div", _hoisted_94, [
                                  _hoisted_95,
                                  _createElementVNode("div", _hoisted_96, [
                                    _createVNode(_component_Checkbox, {
                                      toggled: card.maps || false,
                                      label: "Uses Google Maps",
                                      onClick: ($event: any) => (_ctx.updateCardField(card,{
                      maps: card.maps?!card.maps:true
                    }))
                                    }, null, 8, ["toggled", "onClick"]),
                                    (card.maps)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _hoisted_97,
                                          _createVNode(_component_Checkbox, {
                                            toggled: card.mapsDistance || false,
                                            label: "Uses distance measurement",
                                            onClick: ($event: any) => (_ctx.updateCardField(card,{
                        mapsDistance: card.mapsDistance?!card.mapsDistance:true
                      }))
                                          }, null, 8, ["toggled", "onClick"]),
                                          _hoisted_98,
                                          _createVNode(_component_TextArea, {
                                            default: card.mapsDistanceLocation,
                                            label: "Location distance points to",
                                            limit: 150,
                                            onChange: ($event: any) => (_ctx.updateCardField(card,{
                        mapsDistanceLocation: $event
                      }))
                                          }, null, 8, ["default", "onChange"]),
                                          _hoisted_99,
                                          _createVNode(_component_TextInput, {
                                            label: "Penalty for maps cheat",
                                            placeholder: "Minutes",
                                            type: "number",
                                            default: card.mapsCheatPenalty,
                                            onChange: ($event: any) => (_ctx.updateCardField(card,{
                        mapsDistanceSkipPenalty: $event
                      }))
                                          }, null, 8, ["default", "onChange"])
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]),
                              _createElementVNode("section", null, [
                                _hoisted_100,
                                _createElementVNode("table", null, [
                                  (card.attributions && card.attributions.length)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_101, _hoisted_106))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.attributions, (attr, attrIndex) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      class: _normalizeClass({readonly:_ctx.deletingAttr.includes(attr.id)}),
                                      key: `attr_${attr.id}`
                                    }, [
                                      _createElementVNode("td", null, [
                                        _createVNode(_component_TextInput, {
                                          default: attr.resource,
                                          onChange: ($event: any) => (_ctx.updateAttribution(attr,{
                        resource: $event,
                        author:attr.author,
                        license:attr.license,
                        changes:attr.changes
                      }))
                                        }, null, 8, ["default", "onChange"])
                                      ]),
                                      _createElementVNode("td", null, [
                                        _createVNode(_component_TextInput, {
                                          default: attr.author,
                                          onChange: ($event: any) => (_ctx.updateAttribution(attr,{
                        resource: attr.resource,
                        author: $event,
                        license:attr.license,
                        changes:attr.changes
                      }))
                                        }, null, 8, ["default", "onChange"])
                                      ]),
                                      _createElementVNode("td", null, [
                                        _createVNode(_component_TextInput, {
                                          default: attr.license,
                                          onChange: ($event: any) => (_ctx.updateAttribution(attr,{
                        resource: attr.resource,
                        author: attr.author,
                        license: $event,
                        changes:attr.changes
                      }))
                                        }, null, 8, ["default", "onChange"])
                                      ]),
                                      _createElementVNode("td", null, [
                                        _createVNode(_component_Dropdown, {
                                          options: {
                        active:attr.changes || 0,
                        options:[{
                          text:'False',
                          icon:''
                        },{
                          text:'True',
                          icon:''
                        }]
                      },
                                          onUpdate: ($event: any) => (_ctx.updateAttribution(attr,{
                        resource: attr.resource,
                        author: attr.author,
                        license: attr.license,
                        changes: $event
                      }))
                                        }, null, 8, ["options", "onUpdate"])
                                      ]),
                                      _createElementVNode("td", null, [
                                        _createVNode(_component_IconButton, {
                                          icon: _ctx.deletingAttr.includes(attr.id)?'loader_spinner':'cross',
                                          autoplay: _ctx.deletingAttr.includes(attr.id)?true:false,
                                          loop: _ctx.deletingAttr.includes(attr.id)?true:false,
                                          onClick: ($event: any) => (_ctx.deleteAttribution(card,attrIndex))
                                        }, null, 8, ["icon", "autoplay", "loop", "onClick"])
                                      ])
                                    ], 2))
                                  }), 128)),
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_IconButton, {
                                        text: _ctx.addingAttr.length?'Adding':'Add',
                                        icon: _ctx.addingAttr.length?'loader_spinner':'',
                                        autoplay: _ctx.addingAttr.length?true:false,
                                        loop: _ctx.addingAttr.length?true:false,
                                        onClick: ($event: any) => (_ctx.newAttribution(card))
                                      }, null, 8, ["text", "icon", "autoplay", "loop", "onClick"])
                                    ])
                                  ])
                                ])
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 256))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (!_ctx.$store.state.GameEdit.reordering)
            ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                _createVNode(_component_PageControls, { gameeditmeta: true })
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
}